export function getImageUrl(media: ImageMedia | null, size: string = null): string | null {
    const { url = null } = media || {};
    const { url: sizeUrl = null } = getImageSize(media, size) || {};
    return sizeUrl || url;
}

export default function getImageSize(
    media: ImageMedia | null,
    size: string = null,
): ImageSize | null {
    const { sizes = null, url, width, height } = media || {};
    const originalSize = {
        id: 'original',
        url,
        width,
        height,
    };
    const finalSizes = [originalSize, ...(sizes || []).filter(({ id }) => id !== 'original')];
    const imageSize =
        finalSizes.find(({ id }) => id === size || (id === 'large' && size === 'responsive')) ||
        null;
    if (imageSize !== null) {
        return imageSize;
    }
    return null;
}
